import fetch from "@lib/fetch";

import type { DecisioningStudioActionBankWriteError } from "../decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActions/types";
import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdCacheKeys } from "./constants";
import type {
  PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdProps,
  PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult,
} from "./types";

/** Updates one action bank row. Conman merges only the fields sent, so a partial list is safe. */
export const patchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionId =
  reactQueryMutationAdapter(
    decisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdCacheKeys,
    createMutationFetcherFunctionWithShadowError<DecisioningStudioActionBankWriteError>()(
      (
        props: PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdProps
      ): Promise<PatchDecisioningStudioAgentsAppGroupIdDsaIdDimensionsDimensionActionsActionIdResult> => {
        return fetch(
          `/decisioning_studio_agents/${props.appGroupId}/${props.dsaId}/dimensions/${props.dimension}/actions/${props.actionId}`,
          "PATCH",
          {
            fields: props.fields,
            ...(props.writeMode && { write_mode: props.writeMode }),
          },
          undefined,
          { propagateFetchRequestError: false }
        );
      }
    )
  );
